import { render, staticRenderFns } from "./RemovePaymentMethodDialog.vue?vue&type=template&id=10a33d0b&scoped=true"
import script from "./RemovePaymentMethodDialog.vue?vue&type=script&lang=ts"
export * from "./RemovePaymentMethodDialog.vue?vue&type=script&lang=ts"
import style0 from "./RemovePaymentMethodDialog.vue?vue&type=style&index=0&id=10a33d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a33d0b",
  null
  
)

export default component.exports